import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getMCPConnectorInfo } from 'src/common/Scraper';
import { RootState } from 'src/redux/store';
import { IMCPConnectorInfoResponse } from '../types/mcpTypes';

/**
 * React Query hook to fetch MCP connector info (connection status, URL, etc.).
 * Includes the active user ID in the queryKey to prevent cross-user cache collisions.
 */
export const useGetMCPConnectorInfo = (): UseQueryResult<IMCPConnectorInfoResponse, Error> => {
  const userDetails: any = useSelector(
    (state: RootState) => state?.counter?.userDetails
  );
  const userId = userDetails?._id || userDetails?.id || userDetails?.email;

  return useQuery<IMCPConnectorInfoResponse, Error>({
    queryKey: ['mcpConnectorInfo', userId],
    queryFn: () => getMCPConnectorInfo(),
    enabled: Boolean(userId),
    refetchOnMount: 'always'
  });
};

export default useGetMCPConnectorInfo;
